import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { setLoading } from 'actions';
import * as ordersAPI from 'api/orders';
import { handleError } from 'services/ErrorService/ErrorService';
import DTSelectReason from '../../components/DecisionTree/Common/DTSelectReason/DTSelectReason';
import isEmpty from 'lodash/isEmpty';
import { ReasonContainer } from '../../components/DecisionTree/Common/DTSelectReason/DTSelectReason.styles';

export const useReasons = ({ loadingComponentName, skipImages = true, type }) => {
  const dispatch = useDispatch();
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);

  const [reasons, setReasons] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        dispatch(setLoading(true, loadingComponentName));

        const params = {
          simplrAccountId,
          skipImages,
          type,
        };

        const { reasons: fetchedReasons } = await ordersAPI.getReasons(params);
        if (Array.isArray(fetchedReasons) && !isEmpty(fetchedReasons)) {
          // for use in the dropdown list
          const options = fetchedReasons.map((reason) => ({
            ...reason,
            value: reason.id,
          }));

          setReasons(options);
        } else {
          setReasons([]);
        }
      } catch (error) {
        handleError({ error });
      } finally {
        dispatch(setLoading(false, loadingComponentName));
      }
    })();
  }, [loadingComponentName, skipImages, dispatch, simplrAccountId, type]);

  const ReasonContainerComponent = () => {
    if (isEmpty(reasons)) {
      // TODO: Quick fix. Change this
      return <ReasonContainer>Please Confirm</ReasonContainer>;
    }

    return (
      <DTSelectReason
        selectedReason={selectedReason}
        reasonsList={reasons}
        changeHandler={(reason) => setSelectedReason(reason)}
        type={type}
      />
    );
  };

  return { selectedReason, reasons, ReasonContainerComponent };
};
